import * as React from 'react';
import styles from './new-post-text-filed.module.scss';
import { WIconButton, WStack } from '../../wrappers/wrapper';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import Textarea from 'components/molecules/textarea/textarea';

interface NewPostTextFiledProps {
  images: string[];
  value: string;
  index: number;
  alignments: string[];
  onChangeActiveTextFiled: (index: number) => void;
  onChangeAlignments: (alignments: string[]) => void;
  onChangeText: (value: string) => void;
}

const NewPostTextFiled: React.FC<NewPostTextFiledProps> = ({
  images,
  value,
  index,
  alignments,
  onChangeAlignments,
  onChangeActiveTextFiled,
  onChangeText,
}) => {
  const onJustifyClick = (alignment: string) => {
    alignments[index] = alignment;
    onChangeAlignments(alignments);
  };

  return (
    <div className={styles.newPostTextFiled}>
      <Textarea
        value={value}
        onChange={(e) => onChangeText(e.target.value)}
        placeholder="Write Something"
        className={styles.textFiled}
        onFocus={() => onChangeActiveTextFiled(index)}
      />
      {images[index] && (
        <div className={`${styles.imageBox} ${styles[alignments[index]]}`}>
          <div className={styles.buttons}>
            <WIconButton onClick={() => onJustifyClick('left')}>
              <FormatAlignLeftIcon
                className={`${alignments[index] === 'left' && styles['active']}`}
              />
            </WIconButton>
            <WIconButton onClick={() => onJustifyClick('center')}>
              <FormatAlignJustifyIcon
                className={`${alignments[index] === 'center' && styles['active']}`}
              />
            </WIconButton>
          </div>
          <img className={styles['image']} src={images[index]} alt="new post" />
        </div>
      )}
    </div>
  );
};

export default NewPostTextFiled;
